import React, { useState } from 'react'
import PropTypes from 'prop-types'
// Ui
import Row from 'ui/Row'
import Col from 'ui/Col'
import Text from 'ui/Text'
import Button from 'ui/Button'
import Alert from 'ui/Alert'
// Models
import Lessor from 'models/Lessor'
// Components
import LessorUpdateForm from './LessorUpdateForm'
import LessorUpdateView from './LessorUpdateView'

const LessorUpdateProfile = ({ profile, onLessorUpdated }) => {
  const [editMode, setEditMode] = useState(false)
  return (
    <>
      <Text bold={true} color="#000" paddingBottom="5px">
        General information
      </Text>
      {editMode ? (
        <div className="mt-2 mb-2">
          <Button
            variant="outline-primary"
            width={130}
            onClick={() => setEditMode(false)}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            width={130}
            className="ml-2"
            form="LessorUpdateForm"
          >
            Save changes
          </Button>
        </div>
      ) : (
        <Button
          variant="link"
          underline={true}
          onClick={() => setEditMode(true)}
        >
          Edit details
        </Button>
      )}
      {profile.isRequested && (
        <Row>
          <Col md={9} sm={{ span: 'auto' }} className="mt-3 mb-3">
            <Alert>
              Changes made last {profile.lastRequestUpdate} is being processed.
              Please wait within 24-48hours for it to reflect on your profile
            </Alert>
          </Col>
        </Row>
      )}
      <Row>
        <Col md={10} sm={{ span: 'auto' }}>
          {editMode ? (
            <LessorUpdateForm
              setEditMode={setEditMode}
              profile={profile}
              onLessorUpdated={onLessorUpdated}
            />
          ) : (
            <LessorUpdateView profile={profile} />
          )}
        </Col>
      </Row>
    </>
  )
}
LessorUpdateProfile.propTypes = {
  profile: PropTypes.instanceOf(Lessor),
  onLessorUpdated: PropTypes.func,
}

LessorUpdateProfile.defaultProps = {
  profile: new Lessor(),
  onLessorUpdated: () => {},
}
export default LessorUpdateProfile
